import { all, call } from 'redux-saga/effects';

import { watchLeadsBenchmarkSagas } from 'app/dealer/dashboard/Dashboard/LeadsBenchmark/redux/sagas';
import { watchListingsBenchmarkSagas } from 'app/dealer/dashboard/Dashboard/ListingsBenchmark/redux/sagas';

import { watchDateRangeSagas } from './dateRange/sagas';
import { watchLevelSagas } from './level/sagas';
import { watchWindowBreakpointChange } from './window/sagas';
import { watchGeneralSagas } from './general/sagas';

export function* dealersInsightsSagas() {
  yield all([
    // reducers
    call(watchGeneralSagas),
    call(watchDateRangeSagas),
    call(watchLeadsBenchmarkSagas),
    call(watchListingsBenchmarkSagas),
    call(watchLevelSagas),
    // other
    call(watchWindowBreakpointChange),
  ]);
}
